// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatItem_messagePreview__BIyO4 {
  max-width: 100%;
  min-width: 1px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  color: #8E8E93;
  min-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ChatItem_messagePreview__name__QFbKH {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #272A36;
  margin-right: 4px;
}
.ChatItem_messagePreview__content__RUlVx {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  max-width: 100%;
  min-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ChatItem_messagePreviewDeleted__UcEFB {
  display: inline-flex;
  align-items: center;
  flex-shrink: 1;
}
.ChatItem_messagePreviewDeletedIcon__bE9D9 {
  margin-right: 6px;
}
.ChatItem_messagePreviewSystem__8qf9h {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ChatItem_messagePreviewDraft__iRP3A {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ChatItem_messagePreviewDraft__label__TwZR7 {
  color: #E59F42;
}
.ChatItem_messagePreviewDraft__content__Qkfzd {
  padding-left: 2px;
}

.ChatItem_contentEmpty__zT\\+sC {
  flex-grow: 1;
}
.ChatItem_contentEmpty__zT\\+sC:empty {
  display: none;
}

.ChatItem_avatarUnreadMessageCount__UTjJr {
  position: absolute;
  right: -2px;
  bottom: 0;
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ChatItem/ChatItem.module.scss","webpack://./src/assets/scss/mixins.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EAEA,gBAAA;ECTA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADQF;AAGE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AADJ;AAIE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EC1BF,mBAAA;EACA,gBAAA;EACA,uBAAA;ADyBF;AAIE;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;AAFJ;AAII;EACE,iBAAA;AAFN;AAME;EACE,eAAA;EC1CF,mBAAA;EACA,gBAAA;EACA,uBAAA;ADuCF;AAKE;EACE,eAAA;EC/CF,mBAAA;EACA,gBAAA;EACA,uBAAA;AD6CF;AAGI;EACE,cAAA;AADN;AAII;EACE,iBAAA;AAFN;;AAOA;EACE,YAAA;AAJF;AAME;EACE,aAAA;AAJJ;;AAQA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AALF","sourcesContent":["@import '@/assets/scss/mixins.scss';\n\n.messagePreview {\n  max-width: 100%;\n  min-width: 1px;\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  color: #8E8E93;\n\n  min-height: 18px;\n\n  @include ellipsis;\n\n  &__name {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n    color: #272A36;\n    margin-right: 4px;\n  }\n\n  &__content {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n    max-width: 100%;\n    min-width: 1px;\n\n    @include ellipsis;\n  }\n\n  &Deleted {\n    display: inline-flex;\n    align-items: center;\n    flex-shrink: 1;\n\n    &Icon {\n      margin-right: 6px;\n    }\n  }\n\n  &System {\n    max-width: 100%;\n    @include ellipsis;\n  }\n\n  &Draft {\n    max-width: 100%;\n    @include ellipsis;\n\n    &__label {\n      color: #E59F42;\n    }\n\n    &__content {\n      padding-left: 2px;\n    }\n  }\n}\n\n.contentEmpty {\n  flex-grow: 1;\n\n  &:empty {\n    display: none;\n  }\n}\n\n.avatarUnreadMessageCount {\n  position: absolute;\n  right: -2px;\n  bottom: 0;\n  z-index: 10;\n}\n","@mixin ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin invisible-scroll {\n  overflow: -moz-scrollbars-none;\n  overflow: -moz-hidden-unscrollable;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0 !important;\n    -ms-overflow-style: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messagePreview": `ChatItem_messagePreview__BIyO4`,
	"messagePreview__name": `ChatItem_messagePreview__name__QFbKH`,
	"messagePreview__content": `ChatItem_messagePreview__content__RUlVx`,
	"messagePreviewDeleted": `ChatItem_messagePreviewDeleted__UcEFB`,
	"messagePreviewDeletedIcon": `ChatItem_messagePreviewDeletedIcon__bE9D9`,
	"messagePreviewSystem": `ChatItem_messagePreviewSystem__8qf9h`,
	"messagePreviewDraft": `ChatItem_messagePreviewDraft__iRP3A`,
	"messagePreviewDraft__label": `ChatItem_messagePreviewDraft__label__TwZR7`,
	"messagePreviewDraft__content": `ChatItem_messagePreviewDraft__content__Qkfzd`,
	"contentEmpty": `ChatItem_contentEmpty__zT+sC`,
	"avatarUnreadMessageCount": `ChatItem_avatarUnreadMessageCount__UTjJr`
};
export default ___CSS_LOADER_EXPORT___;
